module.exports = __webpack_public_path__ + "static/img/shiyuxiaochengxu.dd8ed33.jpg";